export const UseDeskActive = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="20" fill="white" />
      <mask
        id="mask0_1087_595"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="42"
        height="42"
      >
        <path
          d="M32.689 11.0109C20.5391 10.6244 10.6242 20.556 11.0109 32.689C11.3637 43.6793 20.3205 52.653 31.311 52.9891C43.4609 53.3756 53.3758 43.444 52.9891 31.311C52.6363 20.3207 43.6795 11.3638 32.689 11.0109ZM32 42.503C26.2024 42.503 21.4972 37.7976 21.4972 32C21.4972 26.2024 26.2024 21.497 32 21.497C37.7976 21.497 42.5028 26.2024 42.5028 32C42.5028 37.7976 37.7976 42.503 32 42.503Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1087_595)">
        <mask
          id="mask1_1087_595"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="-241"
          y="11"
          width="295"
          height="68"
        >
          <path
            d="M53.0021 11.0001H-240.998V78.2001H53.0021V11.0001Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1087_595)">
          <mask
            id="mask2_1087_595"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="9"
            y="11"
            width="44"
            height="44"
          >
            <path
              d="M52.9985 10.9999H9.36249V54.6799H52.9985V10.9999Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_1087_595)">
            <mask
              id="mask3_1087_595"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="9"
              y="10"
              width="44"
              height="45"
            >
              <path
                d="M52.9972 10.9998H9.36115V54.6799H52.9972V10.9998Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1087_595)">
              <path
                d="M61.7244 2.59985H2.81531V61.3998H61.7244V2.59985Z"
                fill="#FA002D"
              />
            </g>
          </g>
          <mask
            id="mask4_1087_595"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="9"
            y="11"
            width="44"
            height="44"
          >
            <path
              d="M52.9985 10.9999H9.36249V54.6799H52.9985V10.9999Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_1087_595)">
            <mask
              id="mask5_1087_595"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="10"
              y="10"
              width="43"
              height="43"
            >
              <path
                d="M52.9978 15.1999L48.7982 10.9999L31.9979 27.7999L15.1982 10.9999L10.998 15.1999L27.7976 31.9999L10.998 48.7999L15.1982 52.9999L31.9979 36.1999L48.7982 52.9999L52.9978 48.7999L36.1981 31.9999L52.9978 15.1999Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask5_1087_595)">
              <mask
                id="mask6_1087_595"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="9"
                y="11"
                width="44"
                height="44"
              >
                <path
                  d="M52.9963 10.9999H9.36029V54.6799H52.9963V10.9999Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask6_1087_595)">
                <path
                  d="M61.7244 2.59991H2.81458V61.3999H61.7244V2.59991Z"
                  fill="white"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
